"use client";

import { HugeiconsIcon } from "@hugeicons/react";
import { PlayIcon as PlaySolidIcon } from "@hugeicons-pro/core-solid-rounded";
import type { FC } from "react";

type Props = {
  className?: string;
  color?: string;
};

const PlayIcon: FC<Props> = ({ className, color = "currentColor" }) => (
  <HugeiconsIcon icon={PlaySolidIcon} className={className} color={color} />
);

export default PlayIcon;
